import { Tag, Card, Typography, Button, message } from 'antd';

import Model from './models';

import { ApiUtils, BaseAPI, Location, useTranslation } from 'soxo-bootstrap-core';

import { Registrations } from '.';

class scrreporttran extends Model {
//api call for generating AI avatar
getAvatar = (formBody) => {
    return ApiUtils.post({
            url: `scrfileslinks/create-ai-avatar`,
            formBody,
    });
};
}
export default scrreporttran;
